module.exports = __webpack_public_path__ + "img/404.a1a135ee.png";